import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { getUidStr } from '../utils/uid';
export default (function (Origin) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Group, _React$Component);

    var _super = _createSuper2(Group);

    function Group(props) {
      var _this;

      _classCallCheck(this, Group);

      _this = _super.call(this, props);
      _this.groupKey = void 0;
      _this.state = {
        data: []
      };
      _this.groupByData = _this.groupByData.bind(_assertThisInitialized(_this));
      _this.groupKey = getUidStr();
      return _this;
    }

    _createClass(Group, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.groupByData();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) this.groupByData();
      }
    }, {
      key: "groupByData",
      value: function groupByData() {
        var _this2 = this;

        var _this$props = this.props,
            groupBy = _this$props.groupBy,
            data = _this$props.data;

        if (typeof groupBy !== 'function') {
          this.setState({
            data: data
          });
          return;
        }

        var groupData = {};
        data.forEach(function (d, i) {
          var g = groupBy(d, i, data);
          if (!groupData[g]) groupData[g || ''] = g ? [_defineProperty({}, _this2.groupKey, g)] : [];
          groupData[g].push(d);
        });
        this.setState({
          data: Object.keys(groupData).reduce(function (p, v) {
            return v ? p.concat(groupData[v]) : groupData[v].concat(p);
          }, [])
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            groupBy = _this$props2.groupBy,
            data = _this$props2.data,
            props = _objectWithoutProperties(_this$props2, ["groupBy", "data"]);

        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            data: this.state.data,
            groupKey: this.groupKey
          }))
        );
      }
    }]);

    return Group;
  }(React.Component), _class.defaultProps = {
    data: []
  }, _temp;
});